import { SharedState } from '$utils/sharedState.svelte';
import type { EnrichedOwner } from '@cometh/connect-sdk-4337';

export type ExtendedEnrichedOwner = EnrichedOwner & {
  isGnosisSafe?: boolean;
};
class StateWalletOwners extends SharedState<ExtendedEnrichedOwner[]> {}

export const stateWalletOwners = new StateWalletOwners([]);
